<div class="content-inputs" [formGroup]="fg">
  <div class="trigger-setting-selector">
    <app-select-v2
      class="fields-selector"
      placeHolder="Settings Options"
      [options$]="configurationFieldsOptions$"
      [canBeEmpty]="true"
      [selectedId]="selectedFieldToAdd"
      (optionOnSelection)="onConfigurationFieldSelection($event)"
    >
    </app-select-v2>
  </div>
  <div class="trigger-setting">
    <div class="trigger-setting-title">
      {{ 'playbooks.triggersConfigurationLabels.ruleUpdates.title' | labelsProvider }}
    </div>
    <div class="field-value-container">
      <div class="field-value-description-container">
        <div>{{ 'playbooks.triggersConfigurationLabels.ruleUpdates.description' | labelsProvider }}</div>
        <img
          class="info-tooltip"
          src="assets/images/common/info.svg"
          height="12px"
          matTooltip="{{ violationRuleUpdatesTooltipText }}"
        />
      </div>
      <app-status-toggle
        [inputStatus]="(violationRuleUpdatesEnabled$ | async) || false"
        (toggleOnClick)="onRuleUpdatesToggled($event)"
      ></app-status-toggle>
    </div>
  </div>
  <div *ngFor="let configuration of selectedConfiguration">
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.violationRule] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.violationRule
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.violationRule' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="categorizedOptions$"
          (optionOnSelection)="updateMultiSelectControl('ruleIds', $event)"
          [selectedIds]="fg.controls['ruleIds'].value"
          [withSearch]="true"
          [withSelectAll]="true"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.violationRule)"
        />
      </div>
      <div class="trigger-setting-warning-container" *ngIf="multipleResourceTypesFromRulesWarningVisible">
        <img src="assets/images/common/warning.svg" />
        <div>
          {{ 'playbooks.multipleResourceTypeWarningText' | labelsProvider }}
        </div>
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.ruleTag] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.ruleTag
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.ruleTag' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="ruleTagOptions$"
          (optionOnSelection)="updateMultiSelectControl('ruleTags', $event)"
          [selectedIds]="fg.controls['ruleTags'].value"
        >
        </app-multi-select>

        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.ruleTag)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.labels] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.labels
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.labels' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <div class="radio-group">
          <mat-radio-group [(ngModel)]="selectedLabelsInclusionStatus" formControlName="labelInclusionStatusControl">
            <mat-radio-button [value]="LabelInclusionStatusEnum.include"> Include </mat-radio-button>
            <mat-radio-button [value]="LabelInclusionStatusEnum.exclude"> Exclude </mat-radio-button>
          </mat-radio-group>
        </div>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.labels)"
        />
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="labelsOptions$"
          (optionOnSelection)="updateLabelsControl($event)"
          [selectedIds]="this.fg.controls['labels'].value?.labelsIds || []"
        >
        </app-multi-select>
      </div>
      <div class="field-value-container labels-waring" *ngIf="containsDeletedLabels">
        <img src="assets/images/common/warning.svg" />
        <div>
          {{ 'playbooks.triggersConfigurationLabels.deletedLabelsWaring' | labelsProvider }}
        </div>
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.severity] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.severity
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.severity' | labelsProvider }}
      </div>

      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="severityOptions$"
          (optionOnSelection)="updateMultiSelectControl('severity', $event)"
          [selectedIds]="fg.controls['severity'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.severity)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.connectors] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.connectors
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.connectors' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="connectorsOptions$"
          (optionOnSelection)="updateMultiSelectControl('connectors', $event)"
          [selectedIds]="fg.controls['connectors'].value"
          [withSearch]="true"
          [withSelectAll]="true"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.connectors)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceStatus] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.resourceStatus
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceStatus' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceStatusOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceStatus', $event)"
          [selectedIds]="fg.controls['resourceStatus'].value"
          [withSearch]="true"
          [withSelectAll]="true"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceStatus)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceSecurityRisk] ===
          configurationFieldStateEnum.selected &&
        configuration === newViolationConfigurationFieldEnum.resourceSecurityRisk
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceSecurityRisk' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceSecurityRiskOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceSecurityRisk', $event)"
          [selectedIds]="fg.controls['resourceSecurityRisk'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceSecurityRisk)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceBusinessCriticality] ===
          configurationFieldStateEnum.selected &&
        configuration === newViolationConfigurationFieldEnum.resourceBusinessCriticality
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceBusinessCriticality' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceBusinessCriticalityOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceBusinessCriticality', $event)"
          [selectedIds]="fg.controls['resourceBusinessCriticality'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceBusinessCriticality)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceGenerativeAiOptions] ===
          configurationFieldStateEnum.selected &&
        configuration === newViolationConfigurationFieldEnum.resourceGenerativeAiOptions
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceGenerativeAiOptions' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceGenerativeAiOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceGenerativeAiOptions', $event)"
          [selectedIds]="fg.controls['resourceGenerativeAiOptions'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceGenerativeAiOptions)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceCreatedBy] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.resourceCreatedBy
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceCreatedBy' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <input
          class="input-container trigger-setting-input"
          formControlName="resourceCreatedBy"
          type="text"
          placeholder="Enter email..."
        />
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceCreatedBy)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceLastModifiedBy] ===
          configurationFieldStateEnum.selected &&
        configuration === newViolationConfigurationFieldEnum.resourceLastModifiedBy
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceLastModifiedBy' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <input
          class="input-container trigger-setting-input"
          formControlName="resourceLastModifiedBy"
          type="text"
          placeholder="Enter your text..."
        />
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceLastModifiedBy)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceCreatedAt] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.resourceCreatedAt
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceCreatedSince' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-date-picker
          class="input-container trigger-setting-date-picker"
          label="tableActionsAndFilters.fromDate"
          (dateOnSelection)="dateSelected('resourceCreatedSince', $event)"
          [startingValue]="fg.controls['resourceCreatedSince'].value"
          [newValueTriggered$]="createdSinceDatesBehavioralSubject$"
        >
        </app-date-picker>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceCreatedAt)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceCreatedAt] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.resourceCreatedAt
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceCreatedUntil' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-date-picker
          class="input-container trigger-setting-date-picker"
          label="tableActionsAndFilters.fromDate"
          (dateOnSelection)="dateSelected('resourceCreatedUntil', $event)"
          [startingValue]="fg.controls['resourceCreatedUntil'].value"
          [minDate]="fg.controls['resourceCreatedUntil'].value"
          [newValueTriggered$]="createdUntilDatesBehavioralSubject$"
        >
        </app-date-picker>
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceFirstSeenAt] ===
          configurationFieldStateEnum.selected &&
        configuration === newViolationConfigurationFieldEnum.resourceFirstSeenAt
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceFirstSeenSince' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-date-picker
          class="input-container trigger-setting-date-picker"
          label="tableActionsAndFilters.fromDate"
          (dateOnSelection)="dateSelected('resourceFirstSeenSince', $event)"
          [startingValue]="fg.controls['resourceFirstSeenSince'].value"
          [newValueTriggered$]="firstSeenSinceDatesBehavioralSubject$"
        >
          >
        </app-date-picker>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceFirstSeenAt)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceFirstSeenAt] ===
          configurationFieldStateEnum.selected &&
        configuration === newViolationConfigurationFieldEnum.resourceFirstSeenAt
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceFirstSeenUntil' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-date-picker
          class="input-container trigger-setting-date-picker"
          label="tableActionsAndFilters.fromDate"
          (dateOnSelection)="dateSelected('resourceFirstSeenUntil', $event)"
          [startingValue]="fg.controls['resourceFirstSeenUntil'].value"
          [minDate]="fg.controls['resourceFirstSeenSince'].value"
          [newValueTriggered$]="firstSeenUntilDatesBehavioralSubject$"
        >
        </app-date-picker>
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newViolationConfigurationFieldEnum.resourceTypes] ===
          configurationFieldStateEnum.selected && configuration === newViolationConfigurationFieldEnum.resourceTypes
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceType' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceTypeOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceTypes', $event)"
          [selectedIds]="fg.controls['resourceTypes'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newViolationConfigurationFieldEnum.resourceTypes)"
        />
      </div>
      <div class="trigger-setting-warning-container" *ngIf="multipleResourceTypesWarningVisible">
        <img src="assets/images/common/warning.svg" />
        <div>
          {{ 'playbooks.multipleResourceTypeWarningText' | labelsProvider }}
        </div>
      </div>
    </div>
  </div>
</div>
